import { render, staticRenderFns } from "./post_user.vue?vue&type=template&id=b6d15000&scoped=true&"
import script from "./post_user.vue?vue&type=script&lang=js&"
export * from "./post_user.vue?vue&type=script&lang=js&"
import style0 from "./post_user.vue?vue&type=style&index=0&id=b6d15000&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6d15000",
  null
  
)

export default component.exports